import changeLoginDialogTemplate from './ChangeLoginDialog.html';

/*****************************************************************************************
 * Dialog allows the user to change login credentials.
 *****************************************************************************************/
/* @ngInject */ export function ChangeLoginDialogService($uibModal) {
  this.show = function () {
    var dialog = $uibModal.open({
      animation: true,
      template: changeLoginDialogTemplate,
      controller: controller,
      size: 'md',
      backdrop: 'static',
      windowClass: 'menu-modal-popup'
    });

    return dialog.result;
  };
}

/***************************************************************************
 * Controller
 ***************************************************************************/
/* @ngInject */ function controller(
  $scope,
  $uibModalInstance,
  CommonSvc,
  Alert
) {
  /** Update Model. */
  $scope.update = {};

  CommonSvc.getUsername().then(function (resp) {
    $scope.update.username = resp.data;
  });

  $scope.passwordsMatch = false;

  /***************************************************************************
   * cancel */
  /**
   * Dismiss the modal
   ***************************************************************************/
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  /***************************************************************************
   * disableSaveButton */
  /**
   * Disable the save button when any required fields have not been filled
   ***************************************************************************/
  $scope.disableSaveButton = function () {
    var disable = true;
    /*-------------------------------------------------------------*/
    /* Clear confirmNewPassword field when newPassword is invalid  */
    /*-------------------------------------------------------------*/
    if ($scope.update.newPassword == null || $scope.update.newPassword < 8)
      $scope.update.confirmNewPassword = '';

    /*------------------------------------------------------*/
    /* Show save button when new password and confirmation  */
    /* are equal, and current password has been entered     */
    /*------------------------------------------------------*/
    if ($scope.update.newPassword == $scope.update.confirmNewPassword) {
      $scope.passwordsMatch = true;
      if ($scope.update.currentPassword != null) disable = false;
    } else {
      $scope.passwordsMatch = false;
      disable = true;
    }

    /*---------------------------------------------------*/
    /* Make save button visible when current password    */
    /* and new username are entered, enable save button  */
    /*---------------------------------------------------*/
    if ($scope.update.newUsername && $scope.update.currentPassword)
      disable = false;

    return disable;
  };

  /***************************************************************************
   * ok */
  /**
   * Make changes to the user's login
   ***************************************************************************/
  $scope.ok = function () {
    /*-------------------*/
    /* Ready the payload */
    /*-------------------*/
    var credentials = {
      userPassword: $scope.update.currentPassword,
      username: $scope.update.newUsername,
      password: $scope.update.newPassword
    };

    /*-----------------------------------------*/
    /* Verify some credential data has changed */
    /*-----------------------------------------*/
    if ((credentials.username || credentials.password || '').length == 0)
      return;

    /*-------------------------*/
    /* Confirm password change */
    /*-------------------------*/
    if (
      $scope.update.newPassword &&
      $scope.update.confirmNewPassword != $scope.update.newPassword
    )
      return;

    CommonSvc.updateCredentials(credentials).then(
      function () {
        Alert.success('Your login has been updated!', 'Login Updated');
        $uibModalInstance.close('Success!');
      },
      function (resp) {
        Alert.error(resp.parsedResponse.message(), 'Update Failed');
      }
    );
  };
}
